import * as React from 'react';
import { Datagrid, ImageField, ListProps, ReferenceField, TextField } from 'react-admin';
import './ProductDatagrid.scss';

export const ProductDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="products-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/><ImageField source="featuredImageUrl" label="FEATURED_IMAGE"/>
			{/*<TextField source="name" label="NAME"/><PriceField source="price" label="PRICE"/>*/}
			<TextField source="description" label="DESCRIPTION"/>
			<ReferenceField source="categoryId" reference="product-categories" label="CATEGORY">
				<TextField source="name"/>
			</ReferenceField>
			{/*<UrlField source="link" label="LINK"/><UrlField source="videoUrl" label="VIDEO_LINK"/>*/}
		</Datagrid>
	);
};
